export const exploreRestaurantsGraphqlQuery = `
    query explore_restaurants (
        $limit: Int!,
        $offset: Int!,
        $lat: Float,
        $lon: Float,
        $radius: Float
    ) {
        explore_restaurants (
            limit: $limit,
            offset: $offset,
            lat: $lat,
            lon: $lon,
            radius: $radius
        ) {
            data {
                restaurant {
                    id,
                    restaurant_name,
                    address,
                    restaurant_logo,
                    slug,
                    inserted_at,
                    show_details,
                    pictures {
                        url
                    },
                    gmaps_info {
                        info {
                            rating,
                            user_ratings_total
                        }
                    }
                }
            },
            hits
        }
    }
`;
